"use client";

import {
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownTrigger,
} from "@nextui-org/react";
import { useTranslations } from "next-intl";

import { CommunicationItem } from "@/components/widgets/Communication/types";
import { writeConfig } from "@/config/communication.config";
import WriteIcon from "@/icons/ui/forms/write.svg";
import { Button, ButtonProps } from "@/ui/Button";
import { cn } from "@/utils/cn";
import { fallBackHandler } from "@/utils/fallback-open-messenger";

interface Props {
  buttonProps?: ButtonProps & { iconSize?: number };
  className?: string;
  children?: React.ReactNode;
  message?: string;
  id?: string;
}

export const WriteButton = ({
  className,
  buttonProps,
  children,
  message,
  id,
}: Props) => {
  const t = useTranslations();

  const generateLinkWithMessage = (item: CommunicationItem) => {
    if (item.value === "whatsapp" && message) {
      const encodedMessage = encodeURIComponent(message);
      return `${item.link}?text=${encodedMessage}`;
    }
    return item.link;
  };

  return (
    <div className={cn("w-full relative", className)}>
      <Dropdown
        placement="bottom"
        classNames={{
          base: "w-full",
          content: "min-w-0 w-full p-0 overflow-hidden rounded",
        }}
      >
        <DropdownTrigger>
          <Button
            disabled={!writeConfig.length}
            className={cn("w-full", buttonProps?.className)}
            color={buttonProps?.color || "gray"}
            size={buttonProps?.size || "md"}
            radius={buttonProps?.radius || "sm"}
            variant={buttonProps?.variant || "bordered"}
          >
            {children ? (
              <>{children}</>
            ) : (
              <>
                <WriteIcon
                  width={buttonProps?.iconSize || 24}
                  height={buttonProps?.iconSize || 24}
                />
                <span className="text-ellipsis overflow-hidden">
                  {t("Text us")}
                </span>
              </>
            )}
          </Button>
        </DropdownTrigger>

        <DropdownMenu
          aria-label="Write options"
          className="w-full p-0"
          itemClasses={{
            base: "min-w-[20rem] outline-none cursor-pointer p-5 rounded-none transition-all duration-200 data-[hover=true]:text-white data-[hover=true]:bg-red data-[hover=true]:opacity-100",
          }}
        >
          {writeConfig.map((item) => (
            <DropdownItem
              key={item.value}
              id={id ? item.id + "_" + id : item.id}
              // href={item.link}
              // target="_blank"
              startContent={
                <item.icon
                  width={35}
                  height={35}
                  className="mr-4 pointer-events-none"
                />
              }
              classNames={{
                title:
                  "text-ellipsis overflow-hidden text-md leading-tight font-medium pointer-events-none",
              }}
              onPress={() => fallBackHandler(generateLinkWithMessage(item))}
            >
              {item.label}
            </DropdownItem>
          ))}
        </DropdownMenu>
      </Dropdown>
    </div>
  );
};
